import { render, staticRenderFns } from "./AtribuirPerfilEmLoteDialog.vue?vue&type=template&id=11499924"
import script from "./AtribuirPerfilEmLoteDialog.vue?vue&type=script&lang=js"
export * from "./AtribuirPerfilEmLoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports